import { BatchLevelSubScreen } from '@v2/pages/batch/details/common/enums/batchDetails.enum';
import { NcFileBatchEventsLink, NcFileBatchEventType } from '@v2/pages/common/enums';
import { createLevelSubScreenLinking } from '@v2/pages/common/helpers';
import { navigationLevels } from '@v2/pages/machines/common/constants';
import { PartDetailsScreen, PartDetailsScreenLink, PartLevelSubScreen } from '@v2/pages/part/details/common/enums/partDetails.enum';
import { PartDetailsJobs, PartDetailsJobsDocuments, PartDetailsJobsTimeline } from '@v2/pages/part/details/modules/jobs';
import { PartDetailsNCFileDocuments } from '@v2/pages/part/details/modules/nc-file/PartDetailsNCFileDocuments';
import {
  PartDetailsNCFilePerformanceActive,
  PartDetailsNCFilePerformanceNavigator,
  PartDetailsNCFilePerformancePaid,
  PartDetailsNCFilePerformanceProductive,
  PartDetailsNCFilePerformanceUtilization,
  PartDetailsNCFileEventsActive,
  PartDetailsNCFileEventsChange,
  PartDetailsNCFileEventsCycle,
  PartDetailsNCFileEventsNavigator,
  PartDetailsNCFileEventsSetup,
  PartDetailsNCFileEventsTrace,
  PartDetailsNCFileTimeline,
  PartDetailsNCFileTimes,
  PartDetailsNCFileVersions,
  PartDetailsNCFile,
  PartDetailsNCFileLinks,
  PartDetailsNCFileTraceability,
} from '../modules/nc-file';
import {
  PartDetailsBatchEventsActive,
  PartDetailsBatchEventsCycle,
  PartDetailsBatchEventsNavigator,
  PartDetailsBatchEventsSetup,
  PartDetailsBatchEventsTrace,
  PartDetailsBatchEventsChange,
  PartDetailsBatch,
  PartDetailsBatchDocuments,
  PartDetailsBatchTimeline,
} from '../modules/batch';
import { PartDetailsPart, PartDetailsPartDocuments, PartDetailsPartTimeline } from '@v2/pages/part/details/modules/part';
import { PartDetailsTools } from '@v2/pages/part/details/modules/tools/PartDetailsTools';
import { PartDetailsBatchNavigator } from './PartDetailsBatchNavigator';
import { PartDetailsJobNavigator } from './PartDetailsJobNavigator';
import { PartDetailsNCFileNavigator } from './PartDetailsNCFileNavigator';
import { PartDetailsPartNavigator } from './PartDetailsPartNavigator';
import { PartDetailsToolNavigator } from './PartDetailsToolNavigator';
import { timelineAvailable } from '@config/navigationRestrictions';
import { injectConditionalArrayItems } from '@helpers';
import {
  filteredBatchLevelSubScreen,
  filteredBatchLevelSubScreenLink,
  filteredJobLevelSubScreen,
  filteredJobLevelSubScreenLink,
  filteredNCFileLevelSubScreen,
  filteredNCFileLevelSubScreenLink,
  filteredPartLevelSubScreen,
  filteredPartLevelSubScreenLink,
} from '../../../common/constants/base.constants';
import { ToolLevelSubScreen, ToolLevelSubScreenLink } from '@v2/pages/tools/details/common/enums/toolsDetails.enum';
import { NCFileLevelSubScreen } from '@v2/pages/nc-file/details/common/enums/ncFileDetails.enum';
import { JobLevelSubScreen } from '@v2/pages/job/common/enums/jobDetails.enum';

export const PartDetailsScreenName = 'PartDetailsV2';

export const partDetailsLinking = {
  path: 'part/details',
  screens: {
    [PartDetailsScreen.PART]: {
      path: PartDetailsScreenLink.PART,
      screens: createLevelSubScreenLinking(PartDetailsScreen.PART, {
        levels: filteredPartLevelSubScreen,
        links: filteredPartLevelSubScreenLink,
      }),
    },
    [PartDetailsScreen.BATCH]: {
      path: PartDetailsScreenLink.BATCH,
      screens: createLevelSubScreenLinking(PartDetailsScreen.BATCH, {
        levels: filteredBatchLevelSubScreen,
        links: filteredBatchLevelSubScreenLink,
        nestedScreens: {
          [BatchLevelSubScreen.TIMES]: {
            screenName: BatchLevelSubScreen.TIMES,
            items: NcFileBatchEventType,
            links: NcFileBatchEventsLink,
          },
        },
      }),
    },
    [PartDetailsScreen.NC_FILE]: {
      path: PartDetailsScreenLink.NC_FILE,
      screens: createLevelSubScreenLinking(PartDetailsScreen.NC_FILE, {
        levels: filteredNCFileLevelSubScreen,
        links: filteredNCFileLevelSubScreenLink,
        nestedScreens: {
          [NCFileLevelSubScreen.TIMES]: {
            screenName: NCFileLevelSubScreen.TIMES,
            items: NcFileBatchEventType,
            links: NcFileBatchEventsLink,
          },
        },
      }),
    },
    [PartDetailsScreen.JOBS]: {
      path: PartDetailsScreenLink.JOBS,
      screens: createLevelSubScreenLinking(PartDetailsScreen.JOBS, {
        levels: filteredJobLevelSubScreen,
        links: filteredJobLevelSubScreenLink,
      }),
    },
    [PartDetailsScreen.TOOLS]: {
      path: PartDetailsScreenLink.TOOLS,
      screens: createLevelSubScreenLinking(PartDetailsScreen.TOOLS, {
        levels: ToolLevelSubScreen,
        links: ToolLevelSubScreenLink,
      }),
    },
  },
};

export const partDetailsConfig = [
  { name: PartDetailsScreen.PART, Component: PartDetailsPartNavigator },
  { name: PartDetailsScreen.BATCH, Component: PartDetailsBatchNavigator },
  { name: PartDetailsScreen.NC_FILE, Component: PartDetailsNCFileNavigator },
  { name: PartDetailsScreen.JOBS, Component: PartDetailsJobNavigator },
  { name: PartDetailsScreen.TOOLS, Component: PartDetailsToolNavigator },
];

export const partDetailsPartConfig = [
  {
    name: `${PartDetailsScreen.PART}${PartLevelSubScreen.GENERAL}`,
    Component: PartDetailsPart,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${PartDetailsScreen.PART}${PartLevelSubScreen.TIMELINE}`,
    Component: PartDetailsPartTimeline,
  }),
  // {
  //   name: `${PartDetailsScreen.PART}${PartLevelSubScreen.TIMES}`,
  //   Component: PartDetailsPart,
  // },
  // {
  //   name: `${PartDetailsScreen.PART}${PartLevelSubScreen.PERFORMANCE}`,
  //   Component: PartDetailsPartPerformanceNavigator,
  // },
  // {
  //   name: `${PartDetailsScreen.PART}${PartLevelSubScreen.VERSIONS}`,
  //   Component: PartDetailsPart,
  // },
  // {
  //   name: `${PartDetailsScreen.PART}${PartLevelSubScreen.LINKS}`,
  //   Component: PartDetailsPart,
  // },
  {
    name: `${PartDetailsScreen.PART}${PartLevelSubScreen.DOCUMENTS}`,
    Component: PartDetailsPartDocuments,
  },
];

export const partDetailsToolConfig = [
  {
    name: `${PartDetailsScreen.TOOLS}${ToolLevelSubScreen.GENERAL}`,
    Component: PartDetailsTools,
  },
];

export const partDetailsBatchConfig = [
  {
    name: `${PartDetailsScreen.BATCH}${BatchLevelSubScreen.GENERAL}`,
    Component: PartDetailsBatch,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${PartDetailsScreen.BATCH}${BatchLevelSubScreen.TIMELINE}`,
    Component: PartDetailsBatchTimeline,
  }),
  {
    name: `${PartDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}`,
    Component: PartDetailsBatchEventsNavigator,
  },
  // {
  //   name: `${PartDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}`,
  //   Component: PartDetailsBatch,
  // },
  {
    name: `${PartDetailsScreen.BATCH}${BatchLevelSubScreen.DOCUMENTS}`,
    Component: PartDetailsBatchDocuments,
  },
];

export const partDetailsNCFileConfig = [
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.GENERAL}`,
    Component: PartDetailsNCFile,
  },
  // Based on task SF-4963
  // ...injectConditionalArrayItems(timelineAvailable, {
  //   name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMELINE}`,
  //   Component: PartDetailsNCFileTimeline,
  // }),

  // {
  //   name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}`,
  //   Component: PartDetailsNCFileTimes,
  // },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}`,
    Component: PartDetailsNCFileEventsNavigator,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}`,
    Component: PartDetailsNCFilePerformanceNavigator,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.VERSIONS}`,
    Component: PartDetailsNCFileVersions,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.LINKS}`,
    Component: PartDetailsNCFileLinks,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.DOCUMENTS}`,
    Component: PartDetailsNCFileDocuments,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TRACEABILITY}`,
    Component: PartDetailsNCFileTraceability,
  }
];

export const partDetailsJobsConfig = [
  {
    name: `${PartDetailsScreen.JOBS}${JobLevelSubScreen.GENERAL}`,
    Component: PartDetailsJobs,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${PartDetailsScreen.JOBS}${JobLevelSubScreen.TIMELINE}`,
    Component: PartDetailsJobsTimeline,
  }),
  // {
  //   name: `${PartDetailsScreen.JOBS}${JobLevelSubScreen.TIMES}`,
  //   Component: PartDetailsJobs,
  // },
  // {
  //   name: `${PartDetailsScreen.JOBS}${JobLevelSubScreen.PERFORMANCE}`,
  //   Component: PartDetailsJobsPerformanceNavigator,
  // },
  // {
  //   name: `${PartDetailsScreen.JOBS}${JobLevelSubScreen.VERSIONS}`,
  //   Component: PartDetailsJobs,
  // },
  // {
  //   name: `${PartDetailsScreen.JOBS}${JobLevelSubScreen.LINKS}`,
  //   Component: PartDetailsJobs,
  // },
  {
    name: `${PartDetailsScreen.JOBS}${JobLevelSubScreen.DOCUMENTS}`,
    Component: PartDetailsJobsDocuments,
  },
];

export const ncFilePerformanceConfig = [
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.active}`,
    Component: PartDetailsNCFilePerformanceActive,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.productive}`,
    Component: PartDetailsNCFilePerformanceProductive,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.paid}`,
    Component: PartDetailsNCFilePerformancePaid,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.utilization}`,
    Component: PartDetailsNCFilePerformanceUtilization,
  },
];

export const ncFileEventsConfig = [
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.CYCLE}`,
    Component: PartDetailsNCFileEventsCycle,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.ACTIVE}`,
    Component: PartDetailsNCFileEventsActive,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.CHANGE}`,
    Component: PartDetailsNCFileEventsChange,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.SETUP}`,
    Component: PartDetailsNCFileEventsSetup,
  },
  {
    name: `${PartDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.TRACE}`,
    Component: PartDetailsNCFileEventsTrace,
  },
];

export const batchEventsConfig = [
  {
    name: `${PartDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.CYCLE}`,
    Component: PartDetailsBatchEventsCycle,
  },
  {
    name: `${PartDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.ACTIVE}`,
    Component: PartDetailsBatchEventsActive,
  },
  {
    name: `${PartDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.CHANGE}`,
    Component: PartDetailsBatchEventsChange,
  },
  {
    name: `${PartDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.SETUP}`,
    Component: PartDetailsBatchEventsSetup,
  },
  {
    name: `${PartDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.TRACE}`,
    Component: PartDetailsBatchEventsTrace,
  },
];
